/** Render the complete configured agreement text without interpreting it as HTML. */
export function LegalDocumentText({ body }: { body: string }) {
  return <div className="legal-document-text">{body.trim().split(/\n\s*\n/).map((block, index) => {
    const content = block.trim();
    if (content.startsWith('## ')) return <h4 key={index}>{content.slice(3)}</h4>;
    if (content.startsWith('# ')) return <h3 key={index}>{content.slice(2)}</h3>;
    if (content.startsWith('**') && content.endsWith('**')) return <strong key={index}>{content.slice(2, -2)}</strong>;
    if (content.startsWith('- ')) return <ul key={index}>{content.split('\n').map((line, i) => <li key={i}>{line.replace(/^-\s*/, '')}</li>)}</ul>;
    return <p key={index}>{content}</p>;
  })}</div>;
}
